import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaMapMarkerAlt } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./NationalEventsParticipation.css";
import Footer from "../Home/Footer";
import NationalEvent1 from "../assets/img/NationalEvent1.png";

const events = [
  {
    id: 1,
    title: "World Food India 2024",
    date: "19-22nd September 2024",
    location: "New Delhi",
    image: NationalEvent1,
  },
  // Add more events here if needed
];

const NationalEventsParticipation = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Split into full rows of 3, and leftover row
  const fullRows = events.slice(0, Math.floor(events.length / 3) * 3);
  const leftover = events.slice(Math.floor(events.length / 3) * 3);

  return (
    <div className="national-events-container">
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url("https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHcNdViXEx5OYoJP4u7WfOVxVgCZrzFfzW6A&s")`,
        }}
        data-aos="fade-up"
      >
        <div className="hero-overlay">
          <h1>National Events Participation</h1>
          <p>
            Engaging in leading national events to drive innovation and
            progress.
          </p>
        </div>
      </section>

      {/* Events Section */}
      <section className="events-section" data-aos="fade-up">
        <h2
          className="separator-title text-center"
          style={{ color: "#d4561a" }}
        >
          Our Recent Participations
        </h2>
        <div className="separator-line mb-5"></div>

        {/* Full rows */}
        <div className="events-grid">
          {fullRows.map((event) => (
            <div key={event.id} className="event-card" data-aos="zoom-in">
              <div className="event-image">
                <img src={event.image} alt={event.title} />
              </div>
              <div className="event-content">
                <h3>{event.title}</h3>
                <div className="event-meta">
                  <span>
                    <FaCalendarAlt /> {event.date}
                  </span>
                  <span>
                    <FaMapMarkerAlt /> {event.location}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Last row - centered if not full */}
        {leftover.length > 0 && (
          <div className="events-grid leftover-row">
            {leftover.map((event) => (
              <div key={event.id} className="event-card" data-aos="zoom-in">
                <div className="event-image">
                  <img src={event.image} alt={event.title} />
                </div>
                <div className="event-content">
                  <h3>{event.title}</h3>
                  <div className="event-meta">
                    <span>
                      <FaCalendarAlt /> {event.date}
                    </span>
                    <span>
                      <FaMapMarkerAlt /> {event.location}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </section>

      {/* Call to Action */}
      <section className="cta-section" data-aos="zoom-in">
        <h2 className="text-white">Join Us in Future Events</h2>
        <p>
          Be a part of our journey. Stay updated with our participation in
          upcoming national events and initiatives.
        </p>
        <Link to="/contact-us" className="cta-btn-national">
          Learn More
        </Link>
      </section>

      <Footer />
    </div>
  );
};

export default NationalEventsParticipation;
